/**
 * wagbappro.id English home page content
 */
import siteConfig from '@/config/site';

const img = (name) => require(`@/assets/wagbappro/${name}`);

const statIcon = (paths) =>
  `<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">${paths}</svg>`;

export const hero = {
  h1: 'Download Latest GB WhatsApp 2026',
  subtitle: 'GB WhatsApp APK v18.80 Anti-Ban',
  description:
    'Download the latest GB WhatsApp APK v18.80 Anti-Ban for 2026 — full features, better privacy controls, and reduced ban risk.',
  cta: 'Download WA GB APK v18.80 Now',
  ctaLink: '/unduh-gb-wa/',
  logo: siteConfig.logo,
  card: {
    title: 'Latest WA GB 2026',
    description:
      'Download the latest GB WhatsApp APK v18.80 Anti-Ban for 2026 — full features, better privacy controls, and reduced ban risk.',
    cta: 'Download GB WhatsApp APK',
    stats: [
      {
        label: 'Version',
        value: 'v18.80',
        icon: statIcon(
          '<path fill="currentColor" d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82zM7 7h.01"/>',
        ),
      },
      {
        label: 'Size',
        value: '±50MB',
        icon: statIcon(
          '<path fill="currentColor" d="M12 3a1 1 0 0 1 1 1v9.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4a1 1 0 1 1 1.414-1.414L11 13.586V4a1 1 0 0 1 1-1z"/><path fill="currentColor" d="M4 18a1 1 0 0 1 1-1h14a1 1 0 0 1 0 2H5a1 1 0 0 1-1-1z"/>',
        ),
      },
      {
        label: 'Android',
        value: '5.0+',
        icon: statIcon(
          '<path fill="currentColor" d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85a.637.637 0 0 0-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67a.643.643 0 0 0-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.81 10.81 0 0 0 1 18h22a10.81 10.81 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"/>',
        ),
      },
      {
        label: 'Updated',
        value: 'May 2026',
        icon: statIcon(
          '<path fill="currentColor" d="M7 2a1 1 0 0 1 1 1v1h8V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1zm12 8H5v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8zM7 12h2v2H7v-2zm4 0h2v2h-2v-2zm4 0h2v2h-2v-2z"/>',
        ),
      },
    ],
  },
  intro: [
    'Sometimes WhatsApp feels too limited — you can\'t hide your online status, privacy controls are basic, and chat features are much the same.',
    'Many people look for alternatives through WA GB or GB WhatsApp APK when they want more control over how they chat.',
    'After trying GB WhatsApp Latest 2026 v18.80, the biggest difference is in privacy controls and flexibility. Things you couldn\'t do in official WhatsApp are much easier to set up here.',
    'Still, it\'s important to understand the risks before using WA GB APK as your main app.',
  ],
};

export const tocSections = [
  { id: 'what-is-wa-gb', title: 'What Is GB WhatsApp APK?' },
  { id: 'key-features', title: 'GB WhatsApp Key Features' },
  { id: 'how-to-install', title: 'How to Download & Install WA GB APK on Android' },
  { id: 'wa-gb-pc', title: 'WA GB for PC' },
  { id: 'update-guide', title: 'How to Update GB WhatsApp Without Losing Chats' },
  { id: 'latest-version', title: 'Latest GB WhatsApp Version' },
  { id: 'comparison', title: 'WA GB vs Official WhatsApp Comparison' },
  { id: 'fix-ban', title: 'How to Fix GB WhatsApp Temporary Ban' },
  { id: 'avoid-ban', title: 'How to Avoid Bans on WA GB App' },
  { id: 'common-issues', title: 'Common WA GB Problems' },
  { id: 'version-history', title: 'GB WhatsApp Pro Old Version History' },
  { id: 'faq', title: 'Frequently Asked Questions (FAQ)' },
];

export const features = [
  {
    title: 'Themes & Full Customization',
    subtitle: 'Make the app look the way you want',
    items: ['Thousands of ready-made themes', 'Change colors, fonts, and chat bubbles', 'More flexible custom UI'],
  },
  {
    title: 'Advanced Privacy',
    subtitle: 'Full control over your online presence',
    items: ['Hide "online" status', 'Hide "last seen"', 'Disable blue ticks', 'Read messages without being seen'],
  },
  {
    title: 'Send Larger Files',
    subtitle: 'Less restrictive file sharing limits',
    items: ['Send large videos', 'Send many photos at once', 'Broader file format support'],
  },
  {
    title: 'Smart Auto Reply',
    subtitle: 'Automate messages with ease',
    items: ['Automatic replies', 'Custom messages for specific contacts', 'Great for small businesses'],
  },
  {
    title: 'Scheduled Messages',
    subtitle: 'Send messages at the time you choose',
    items: ['Schedule birthday messages', 'Automatic reminders', 'Bulk sending support'],
  },
  {
    title: 'Dual WhatsApp Accounts',
    subtitle: 'Use 2 accounts on one device',
    items: ['No need for a separate clone app', 'Separate work and personal accounts', 'More convenient'],
  },
  {
    title: 'Anti-Delete Messages',
    subtitle: 'See messages even after they\'re deleted',
    items: ['Read deleted messages from senders', 'Never lose chat context'],
  },
  {
    title: 'Download Status',
    subtitle: 'Save friends\' status updates instantly',
    items: ['Photo & video statuses', 'No extra app needed', 'One-click download'],
  },
  {
    title: 'Built-in App Lock',
    subtitle: 'Extra security inside the app',
    items: ['PIN / pattern lock', 'Protect private chats', 'No external app lock needed'],
  },
  {
    title: 'Anti-Ban Mode (Claimed Feature)',
    subtitle: 'Some versions claim account protection features',
    items: ['May reduce detection risk', 'Unofficial anti-ban patches'],
  },
  {
    title: 'DND Mode (Do Not Disturb)',
    subtitle: 'Focus without interruptions',
    items: ['Disconnect WhatsApp only', 'Stay online in other apps'],
  },
  {
    title: 'Broadcast & Message Tools',
    subtitle: 'Broader communication features',
    items: ['Less strict broadcast limits', 'Bulk sending tools', 'Faster chat management'],
  },
];

export const installSteps = [
  {
    title: 'Download the WA GB APK file',
    image: img('content/06-install-step-1-download.webp'),
    items: [
      'Open your browser (Chrome / Firefox)',
      'Search for: "GB WhatsApp APK latest version"',
      'Choose a trusted APK provider site',
      'Tap the Download APK button',
      'Wait until the file finishes downloading',
    ],
  },
  {
    title: 'Enable "Unknown Sources"',
    image: img('content/07-install-step-2-unknown-sources.webp'),
    items: [
      'Go to Settings',
      'Open Security / Privacy',
      'Enable Install Unknown Apps / Unknown sources',
      'Allow your browser or File Manager',
    ],
  },
  {
    title: 'Find the APK file',
    image: img('content/08-install-step-3-find-apk.webp'),
    items: ['Open File Manager', 'Go to the Download folder', 'Look for: GBWhatsApp.apk'],
  },
  {
    title: 'Install the app',
    image: img('content/09-install-step-4-install.webp'),
    items: ['Tap the APK file', 'Tap Install', 'Wait for installation to finish'],
  },
  {
    title: 'Set up your account',
    image: img('content/10-install-step-5-setup.webp'),
    items: [
      'Open GB WhatsApp',
      'Enter your phone number',
      'Verify the OTP code',
      'Restore chats (if you have a backup)',
    ],
  },
  {
    title: 'Extra settings (optional)',
    image: img('content/11-install-step-6-optional.webp'),
    items: [
      'Disable Google Play Protect if it blocks installation',
      'Use a secondary number for safety',
      'Back up your official WhatsApp chats first',
    ],
  },
];

export const installSection = {
  subtitle:
    'Follow the steps below to download and install GB WhatsApp on your Android device.',
  noteCard: {
    title: 'Important Notes',
    items: [
      'GB WhatsApp is not an official WhatsApp Inc. app.',
      'Not available on Google Play Store.',
      'Security and privacy risks should be understood.',
    ],
  },
  alertCard: {
    title: 'Important!',
    text:
      'Only download WA GB APK from trusted sources. Avoid modified files from unknown sites to keep your device and chat data safe.',
  },
};

export const comparisonRows = [
  {
    feature: 'Privacy features',
    gb: 'More flexible (hide status, ticks, etc.)',
    official: 'Limited and standard',
  },
  {
    feature: 'Customization',
    gb: 'Themes, fonts, and UI can be changed',
    official: 'No theme support',
  },
  {
    feature: 'Extra features',
    gb: 'Many extras (auto reply, clone chat, etc.)',
    official: 'Official features only',
  },
  {
    feature: 'Security',
    gb: 'Unofficial, varies by version',
    official: 'More secure and stable',
  },
  {
    feature: 'Updates',
    gb: 'Manual via APK',
    official: 'Automatic via Play Store',
  },
];

export const banFixSteps = [
  {
    title: 'Wait for the ban period to end',
    desc:
      'Temporary bans usually last from a few hours to several days. Once the time is up, your account should work again automatically.',
  },
  {
    title: 'Back up chats and media',
    desc:
      'While waiting, open GB WhatsApp settings and create a backup so all messages and files stay safe if you need to reinstall.',
  },
  {
    title: 'Use the latest app version',
    desc:
      'After the ban ends, make sure you install the latest WA GB APK or GB WhatsApp anti-ban version to reduce the chance of it happening again.',
  },
  {
    title: 'Reinstall the app if needed',
    desc:
      'If problems continue, uninstall the old version and reinstall from a trusted source, then log in again with the same number.',
  },
  {
    title: 'Restore chat data',
    desc: 'When logging in, choose restore to bring back all conversations and media from your previous backup.',
  },
];

export const avoidBanTips = [
  {
    title: 'Always use the latest version',
    desc:
      'Make sure you\'re on the latest WA GB APK or GB WhatsApp anti-ban build so the app stays stable and aligned with recent updates.',
  },
  {
    title: 'Avoid switching versions too often',
    desc: 'Frequent reinstalls or version hopping can cause data mismatches and increase detection risk.',
  },
  {
    title: 'Use features normally',
    desc: 'Avoid excessive activity like spam, over-broadcasting, or heavy automation in a short time.',
  },
  {
    title: 'Back up data regularly',
    desc: 'Backups keep all chats and media safe if errors occur or you need to reinstall the app.',
  },
  {
    title: 'Download from trusted sources',
    desc: 'Make sure your WA GB App file comes from a reliable source so you don\'t end up with a harmful modified build.',
  },
];

export const commonProblems = [
  {
    icon: '🔐',
    title: 'Login Problem',
    desc: 'Can\'t verify your number or OTP code doesn\'t arrive.',
    solution:
      'Make sure your number is active, use a stable connection, then try logging in again after a few minutes. If it still fails, reinstall the latest WA GB APK.',
  },
  {
    icon: '💬',
    title: 'Chat Loss',
    desc: 'Chats disappear after an update or reinstall.',
    solution: 'Use GB WhatsApp\'s backup feature before updating, then choose "restore chat" when you log back in.',
  },
  {
    icon: '⚠️',
    title: 'Crash / Error',
    desc: 'The app keeps closing or won\'t open.',
    solution:
      'Remove the old version, reinstall the latest GB WhatsApp anti-ban build, and make sure your device has enough storage space.',
  },
  {
    icon: '🔔',
    title: 'Notification Issue',
    desc: 'Messages arrive but notifications don\'t show.',
    solution: 'Enable notification permissions in phone settings and turn off battery optimization for WA GB App.',
  },
  {
    icon: '📦',
    title: 'Installation Problem',
    desc: 'APK fails to install or shows "App not installed" error.',
    solution:
      'Uninstall the old version first, then make sure the WA GB APK file is compatible with your Android version.',
  },
];

export const oldVersions = [
  { version: 'v21.30', date: 'May 2026', baseVersion: '2.26.10.72', size: '99 MB', android: 'Android 5.0+' },
  { version: 'v21.25', date: 'May 2026', baseVersion: '2.26.10.72', size: '95 MB', android: 'Android 5.1+' },
  { version: 'v24.15', date: 'Custom Release', baseVersion: 'Custom Build', size: '90 MB', android: 'Android 5.0+' },
  { version: 'v23.00', date: '2026', baseVersion: '2.24.25.70', size: '85 MB', android: 'Android 5.0+' },
  { version: 'v18.80', date: 'March 2026', baseVersion: '2.24.25.71', size: '99 MB', android: 'Android 5.0+' },
  { version: 'v18.70', date: 'February 2026', baseVersion: '2.24.25.71', size: '99 MB', android: 'Android 5.0+' },
  { version: 'v18.30', date: 'February 2025', baseVersion: '2.24.25.71', size: '80 MB', android: 'Android 5.0+' },
  { version: 'v18.20', date: 'December 2024', baseVersion: '2.24.25.71', size: '77.2 MB', android: 'Android 5.0+' },
  { version: 'v18.10', date: 'November 2024', baseVersion: '2.24.16.76', size: '77.2 MB', android: 'Android 5.0+' },
  { version: 'v18.00', date: 'October 2024', baseVersion: '2.24.16.76', size: '77.2 MB', android: 'Android 5.0+' },
  { version: 'v17.85', date: 'September 2024', baseVersion: '2.24.16.45', size: '74.4 MB', android: 'Android 5.0+' },
  { version: 'v17.55', date: 'October 2023', baseVersion: '2.23.18.79', size: '70.3 MB', android: 'Android 4.1+' },
  { version: 'v17.20', date: 'December 2022', baseVersion: '2.22.24.78', size: '56.5 MB', android: 'Android 4.1+' },
  { version: 'v15.40', date: 'September 2021', baseVersion: '2.21.7.14', size: '45 MB', android: 'Android 4.1+' },
  { version: 'v13.50', date: 'August 2021', baseVersion: '2.21.7.14', size: '45 MB', android: 'Android 4.1+' },
  { version: 'v8.60', date: 'November 2020', baseVersion: '2.20.157', size: '31.3 MB', android: 'Android 4.0.3+' },
];

export const faqItems = [
  {
    q: 'Is GB WhatsApp safe to use?',
    a: 'GB WhatsApp is a modified app with no official support. It may work fine for daily use, but risks like bugs or account bans still exist.',
  },
  {
    q: 'Can WA GB APK be used without getting banned?',
    a: 'GB WhatsApp anti-ban versions are designed to lower ban risk, but there\'s no 100% guarantee since it\'s not an official app.',
  },
  {
    q: 'Can chats be lost during an update?',
    a: 'Chats can be lost if you don\'t back up first. Always back up before updating to keep your data safe.',
  },
  {
    q: 'Can GB WhatsApp be used on PC?',
    a: 'Yes — through an Android emulator, linked devices, or screen mirroring from your phone to PC.',
  },
  {
    q: 'Do I need to uninstall before updating?',
    a: 'Not always. Some versions update in place, but if you hit errors, back up and reinstall.',
  },
  {
    q: 'What\'s the difference between WA GB and official WhatsApp?',
    a: 'WA GB adds customization and more flexible privacy options, while official WhatsApp is more stable and secure.',
  },
];

export const userFeedback = [
  { text: 'Updated to v18.80 — much smoother, no lag while chatting.', author: 'Alex, London' },
  { text: 'Backup worked and all chats came back normally after the update.', author: 'Sarah, Sydney' },
  { text: 'This latest version is more stable than before — good for daily use.', author: 'Mike, Toronto' },
];

const infoIcon = (paths) =>
  `<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#25d366" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;

export const whatIsSection = {
  id: 'what-is-wa-gb',
  titlePrefix: 'What Is',
  titleHighlight: 'GB WhatsApp APK?',
  paragraphs: [
    '<strong>GB WhatsApp APK</strong> is a modified version of the official WhatsApp app that adds extra features like better privacy controls, theme customization, anti-ban options, and the ability to send larger files.',
    'Developed by third parties and not available on Google Play Store, users need to download it as an APK file. In the <strong>WA GB</strong> ecosystem, this version is popular for its flexible appearance settings and chat controls compared to official WhatsApp.',
  ],
  notice:
    'GB WhatsApp is not an official WhatsApp Inc. app. Using third-party apps carries certain risks you should understand before installing.',
  noticeLabel: 'Important Note:',
  illustration: img('content/04-home-what-is-gb.webp'),
  illustrationAlt: 'GB WhatsApp APK illustration',
  appInfoTitle: 'GB WhatsApp App Information',
  appInfoItems: [
    {
      label: 'Name',
      value: 'WhatsApp GB APK',
      icon: infoIcon('<rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/>'),
    },
    {
      label: 'Category',
      value: 'Modified messaging app',
      icon: infoIcon('<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><path d="M7 7h.01"/>'),
    },
    {
      label: 'Based on',
      value: 'WhatsApp',
      icon: infoIcon('<path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.637-.637 0 0 0-.83.22l-1.88 3.24a11.43 11.43 0 0 0-8.94 0L5.65 5.67a.643.643 0 0 0-.87-.2c-.28.18-.37.54-.22.83L6.4 9.48A10.81 10.81 0 0 0 1 18h22a10.81 10.81 0 0 0-5.4-8.52zM7 15.25a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5zm10 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5z"/>'),
    },
    {
      label: 'Focus',
      value: 'Customization & feature control',
      icon: infoIcon('<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>'),
    },
    {
      label: 'Status',
      value: 'Unofficial',
      icon: infoIcon('<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>'),
    },
    {
      label: 'Platform',
      value: 'Android',
      icon: infoIcon('<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>'),
    },
  ],
};

export const images = {
  pcHero: img('content/14-pc-hero.webp'),
};

export const homeIntro = [
  'Sometimes WhatsApp feels too limited — you can\'t hide your online status, privacy controls are basic, and chat features are much the same.',
  'Many people look for alternatives through <a href="/en/"><strong>WA GB</strong></a> or GB WhatsApp APK when they want more control over how they chat.',
  'After trying <strong>GB WhatsApp Latest 2026 v18.80</strong>, the biggest difference is in privacy controls and flexibility. Things you couldn\'t do in official WhatsApp are much easier to set up here.',
  'Still, it\'s important to understand the risks before using <strong>WA GB APK</strong> as your main app.',
];

export const homeCopy = {
  tocTitle: 'Table of Contents',
  tocMetaSuffix: 'guide topics',
  pc: {
    intro:
      'WA GB for PC lets you run GB WhatsApp on your computer for a more comfortable chatting experience on a larger screen. Although the app is built for Android, there are several ways to access it on PC without losing core functionality.',
    imgAlt: 'GB WhatsApp on computer',
    methodsHeading: '💻 How to Use WA GB on PC',
    methods: [
      {
        title: 'Using an Android Emulator',
        desc: 'Install an emulator like BlueStacks or LDPlayer on your PC, then run the WA GB APK inside the emulator — just like on a phone.',
      },
      {
        title: 'Linked Devices',
        desc: 'Open WA GB on your phone, go to linked devices, and scan the QR code in your PC browser — similar to WhatsApp Web.',
      },
      {
        title: 'Screen Mirroring',
        desc: 'Use apps like AirDroid or other mirroring tools to display your phone screen on PC and control WA GB from your computer.',
      },
    ],
    cta: 'Learn More for PC',
    ctaLink: '/unduh-gb-whatsapp-untuk-pc/',
  },
  update: {
    intro:
      'Updating <strong>WA GB Pro</strong> can be done safely as long as your chat data is backed up properly beforehand. With the right steps, all chats, groups, and media in your GB WhatsApp <strong>anti-ban</strong> app can be kept without losing old data.',
    stepsHeading: 'Steps:',
    steps: [
      'Make sure you\'ve backed up chats in GB WhatsApp settings',
      'Download the latest APK that matches your previous version',
      'Install the new APK without removing the old app (if possible)',
      'Open the app and verify your phone number',
      'Choose restore to bring back all chats',
    ],
    noteHeading: 'Quick Note',
    noteText:
      'Always back up before updating to avoid data loss. Use a trusted WA GB APK source and avoid files from unknown sites. Also stick to compatible versions so GB WhatsApp anti-ban runs more smoothly after the update.',
  },
  version: {
    titleSuffix: ' v18.80',
    intro:
      'GB WhatsApp v18.80 is the latest WA GB APK with improved stability, lighter performance, and better compatibility across Android devices. This version is designed for smoother chatting with a more complete set of extra features.',
    whatsNewHeading: 'What\'s new in this version:',
    whatsNew: [
      'More stable performance and faster response',
      'Bug fixes from previous versions',
      'Better compatibility with newer Android versions',
      'Optimized GB WhatsApp anti-ban privacy features',
      'Smoother and lighter user experience',
    ],
    feedbackHeading: '💬 User Feedback',
    cta: '👉 Download WA GB APK v18.80 Now',
    ctaLink: '/unduh-gb-wa/',
  },
  comparison: {
    intro:
      'Many users choose between WA GB APK and official WhatsApp based on feature needs and ease of use. Both handle basic chat and calls, but differ in extra features, flexibility, and security level.',
    heading: '📊 Key Comparison',
    tableHeaders: {
      feature: 'Feature',
      gb: 'WA GB APK (GB WhatsApp anti-ban)',
      official: 'Official WhatsApp',
    },
    notice:
      'GB WhatsApp anti-ban is designed to reduce ban risk, but it remains a modified app.',
  },
  banFix: {
    intro: [
      'Using GB WhatsApp carries account ban risk — temporary or permanent. This usually happens due to unstable versions or unusual detected activity.',
      'If you run into this issue, here are steps to recover your account and secure your chat data.',
    ],
    stepsHeading: 'Steps You Can Take',
  },
  avoidBan: {
    intro:
      'WA GB App or GB WhatsApp offers more flexible features than the official app, but account bans are still possible if you\'re not careful. With the right usage habits, that risk can be significantly reduced.',
    tipsHeading: 'Safer Usage Tips',
  },
  problems: {
    solutionLabel: 'Solution:',
    cta: 'View Full Solutions',
    ctaLink: '/wa-gb-solusi-masalah/',
  },
  oldVersions: {
    intro:
      'For users who want to try older GB WhatsApp Pro builds, various versions are available to match device needs and Android compatibility. Each version differs in size, features, and stability.',
    heading: '📊 Old Version List',
    tableHeaders: {
      version: 'Version',
      date: 'Release Date',
      baseVersion: 'Base Version',
      size: 'File Size',
      android: 'Minimum Android',
    },
    cta: 'View All Old Versions',
    ctaLink: '/wa-gb-versi-lama/',
  },
};
